import { useApiRequest } from '@/lib/http-utils'
import { useQuery } from '@tanstack/react-query'
import { taskManagerApiPaths } from './_paths'

export type AgentRegistryType = 'worker' | 'generated' | 'workflow'

export type AgentToolInput = {
  title: string
  description: string
  type: 'string'
  anyOf: string[] | null
}

export type AgentTool = {
  id: string
  name: string
  description: string
  input: AgentToolInput[]
}

export type AgentRegistry = {
  id: string
  externalId: string
  name: string
  description: string
  type: AgentRegistryType
  tools?: AgentTool[]
}

type AgentRegistryAPIResponse = {
  data: AgentRegistry[]
}

export type UseAgentRegistrySearchParams = {
  page?: number
  limit?: number
}

export function useAgentRegistryQuery() {
  const { apiRequest, domainId } = useApiRequest()
  return useQuery<AgentRegistryAPIResponse>({
    queryKey: ['agent-registry', domainId],
    queryFn: async () => {
      const response = await apiRequest({
        path: taskManagerApiPaths.agents({ domainId }),
      })
      const json = (await response.json()) as AgentRegistryAPIResponse

      return json
    },
  })
}
